import { Component, Output, EventEmitter } from '@angular/core';
import { Case } from 'src/app/models/case';
import { ServiceRequest } from 'src/app/models/service.request';
import { Settings } from 'src/app/services/settings';
import { DwUtils } from '../utils/dw-utils';

@Component({
	selector: 'app-reclose-dialog',
	templateUrl: './reclose-dialog.component.html',
	styleUrls: ['./reclose-dialog.component.css']
})
export class RecloseDialogComponent {

	supressEmails = 1;
	public dateSubmitted;
	public dateClosed;
	public strErr: string | null = '';
	selectedCase: Case;
	selectedRequest: ServiceRequest;
	enableRequestedSubmittedDate = true;
	enableCompletedClosedDate = true;

	@Output() cancelClicked = new EventEmitter();
	@Output() submitClicked = new EventEmitter<any>();

	showRequestRecloseHandler(record: ServiceRequest) {
		this.selectedRequest = record;
		this.dateSubmitted = Settings.getInstance().formatDate(this.selectedRequest.dateCreated, 'yyyy-MM-dd');
		if (this.selectedRequest.dateCompleted !== null) {
			this.dateClosed = Settings.getInstance().formatDate(this.selectedRequest.dateCompleted, 'yyyy-MM-dd');
		}
		else {
			this.dateClosed = '';
			DwUtils.setFocus('dateclosedid');
		}
		this.enableRequestedSubmittedDate = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_REOPEN_MYAGENCY_REQUEST_DATE', "EXECUTE");
		this.enableCompletedClosedDate = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_REOPEN_MYAGENCY_DATE_COMPLETED', "EXECUTE");
	}
	showCaseRecloseHandler(record: Case) {
		this.selectedCase = record;
		this.dateSubmitted = Settings.getInstance().formatDate(this.selectedCase.dateOpened, 'yyyy-MM-dd');
		this.dateClosed = Settings.getInstance().formatDate(this.selectedCase.dateClosed, 'yyyy-MM-dd');
	}

	public validateFields(): boolean {

		this.strErr = '';

		if (DwUtils.chkValidDate(this.dateSubmitted) === false) {
			this.strErr = 'Error: Badly formed date - should be YYYY-MM-DD';
			DwUtils.highlightFocus('datesubmittedid');
			return false;
		}

		if (DwUtils.chkValidDate(this.dateClosed) === false) {
			this.strErr = 'Error: Badly formed date - should be YYYY-MM-DD';
			DwUtils.highlightFocus('dateclosedid');
			return false;
		}
		return true;
	}


	cancelSubmitRecord() {
		this.cancelClicked.emit();
	}
	submitRecord() {
		if (!this.validateFields()) {
			return;
		}
		function toUtcForEstMidnight(dateStr: string): Date {
			const [y, m, d] = dateStr.split('-').map(Number);
			return new Date(Date.UTC(y, m - 1, d, 5, 0, 0)); // Midnight EST == 5AM UTC
		}

		const payload = {
			dateSubmitted: toUtcForEstMidnight(this.dateSubmitted).toISOString(),
			dateClosed: toUtcForEstMidnight(this.dateClosed).toISOString(),
			supressEmails: this.supressEmails
		};

		this.submitClicked.emit(payload);
	}
}
